import { useEffect, useMemo, useState } from 'react';

import { useElementPosition } from './useElementPosition';
import { useScreenResize } from './useScreenResize';

export const useNeedsScroll = () => {
  const [needScroll, setNeedScroll] = useState<boolean>(false);
  const resizeVal = useScreenResize(100);
  const {
    elementRef,
    position: { bottom },
    updatePosition,
  } = useElementPosition();

  // set scroll needs
  useEffect(() => {
    if (bottom) {
      const windowHeight = window.innerHeight;
      setNeedScroll(windowHeight < bottom);
    }
  }, [resizeVal, bottom]);

  return useMemo(
    () => ({
      elementRef,
      needScroll,
      updatePosition,
    }),
    [needScroll, elementRef, updatePosition],
  );
};
